<template>
    <input
        class="ui-input"
        v-bind="$attrs"
        :value="newValue"
        @input="onInput"
    >
</template>

<style lang="scss">
    .ui-input {
        font-size: 1rem;
        display: block;
        width: 100%;
        line-height: 18px;
        padding: 5px 10px;;
    }
</style>

<script>
export default {
  props: {
    value: [Number, String],
  },

  data() {
    return {
      newValue: this.value,
    };
  },

  watch: {
    value(value) {
      this.newValue = value;
    },

    newValue(value) {
      this.$emit('input', value);
    },
  },

  methods: {
    onInput(event) {
      this.$nextTick(() => { this.newValue = event.target.value; });
    },
  },
};
</script>
